import { apiClient } from './client';
import type { TrainingSetTemplate, TrainingSetTemplateCreateRequest, TrainingSetTemplateUpdateRequest } from '../types/api';

export const templateApi = {
  /**
   * Get all templates for the authenticated coach
   */
  async getTemplates(): Promise<TrainingSetTemplate[]> {
    return apiClient.get<TrainingSetTemplate[]>('/v1/templates');
  },

  /**
   * Get a single template by ID
   */
  async getTemplate(id: number): Promise<TrainingSetTemplate> {
    return apiClient.get<TrainingSetTemplate>(`/v1/templates/${id}`);
  },

  /**
   * Create a new training set template
   */
  async createTemplate(request: TrainingSetTemplateCreateRequest): Promise<TrainingSetTemplate> {
    return apiClient.post<TrainingSetTemplate>('/v1/templates', request);
  },

  /**
   * Update an existing template
   */
  async updateTemplate(id: number, request: TrainingSetTemplateUpdateRequest): Promise<TrainingSetTemplate> {
    return apiClient.put<TrainingSetTemplate>(`/v1/templates/${id}`, {
      ...request,
      id, // Ensure id is included in the request body
    });
  },

  /**
   * Delete a template (soft delete)
   */
  async deleteTemplate(id: number): Promise<void> {
    return apiClient.delete<void>(`/v1/templates/${id}`);
  },
};
